<template>
  <div>
    <b-card>
      <div>
        <b-card-body title="جزییات درگاه">
          <hr class="my-4" />
          <br />
          <b-alert variant="danger" :show="errors.length > 0">
            <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
          </b-alert>
          <b-alert variant="success" :show="success_errors.length > 0">
            <p v-for="x in success_errors" v-bind:key="x">{{ x }}</p>
          </b-alert>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                label="تاریخ درخواست:"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="Gateway.created_at"
                  disabled
                ></b-form-input> </b-form-group
            ></b-col>
            <b-col> </b-col>
            <b-col> </b-col>
            <b-col> </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                label="نام مالک درگاه:"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="user_info.name"
                  required
                  placeholder="نام مالک درگاه"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-2"
                label="شماره موبایل:"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="user_info.mobile"
                  required
                  placeholder="شماره موبایل"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-3"
                label="ایمیل:"
                label-for="input-3"
              >
                <b-form-input
                  id="input-3"
                  v-model="user_info.email"
                  required
                  disabled
                  placeholder="ایمیل"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                label="نام وبسایت:"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="Gateway.website_name"
                  required
                  disabled
                  placeholder="نام وبسایت"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-2"
                label="آدرس وبسایت:"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="Gateway.website"
                  required
                  disabled
                  placeholder="آدرس وبسایت"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-3"
                label="نام انگلیسی وبسایت:"
                label-for="input-3"
              >
                <b-form-input
                  id="input-3"
                  v-model="Gateway.website_en_name"
                  required
                  disabled
                  placeholder="نام انگلیسی وبسایت"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-4"
                label="توضیحات:"
                label-for="input-4"
              >
                <b-form-input
                  id="input-4"
                  v-model="Gateway.description"
                  required
                  disabled
                  placeholder="توضیحات"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-5"
                label="گروه بندی:"
                label-for="input-5"
              >
                <MDDropdown
                  v-bind:group="9"
                  v-model="Gateway.mdid9_category"
                  disabled
                ></MDDropdown>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group id="input-group-6" label="نوع:" label-for="input-6">
                <MDDropdown
                  v-bind:group="14"
                  v-model="Gateway.mdid14_direct_gate"
                  disabled
                ></MDDropdown>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-7"
                label="واحد پولی:"
                label-for="input-7"
              >
                <MDDropdown
                  v-bind:group="12"
                  v-model="Gateway.mdid12_money_type"
                  disabled
                ></MDDropdown>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-8"
                label="دوره تسویه:"
                label-for="input-8"
              >
                <MDDropdown
                  v-bind:group="104"
                  v-model="Gateway.mdid104_payment_priority"
                  disabled
                ></MDDropdown>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-5"
                label="کد استان:"
                label-for="input-5"
                description="کد استان لطفا با 0 وارد شود"
              >
                <b-form-input
                  id="input-4"
                  v-model="Gateway.pre_phone"
                  required
                  placeholder="کد استان"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-5"
                label="تلفن ثابت:"
                label-for="input-5"
                description="تلفن باید بدون پیش کد وارد شود"
              >
                <b-form-input
                  id="input-4"
                  v-model="Gateway.phone_support"
                  required
                  disabled
                  placeholder="تلفن ثابت"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-checkbox
                id="percent_price"
                v-model="percent_price"
                name="percent_price"
                value="accepted"
                unchecked-value="not_accepted"
                disabled
              >
                درصدی از مبلغ تراکنش
              </b-form-checkbox>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-2"
                label="درصد کارمزد:"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="Gateway.pourcents_percent"
                  placeholder="درصد کارمزد"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-2"
                label="حداکثر مبلغ کارمزد:"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="Gateway.pourcents_percent_max_value"
                  placeholder="حداکثر مبلغ کارمزد"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-checkbox
                id="fix_price"
                v-model="fix_price"
                name="fix_price"
                value="accepted"
                unchecked-value="not_accepted"
                disabled
              >
                مبلغ ثابت
              </b-form-checkbox>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-2"
                label="مبلغ کارمزد ثابت:"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="Gateway.pourcents_value"
                  placeholder="مبلغ کارمزد ثابت"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col></b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col>
              <b-form-group
                id="input-group-9"
                label="وضعیت درخواست درگاه:"
                label-for="input-9"
              >
                <b-form-input
                  id="input-2"
                  disabled
                  v-model="Gateway.request_status.title"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col> </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-2"
                label="ترمینال:"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="Gateway.terminal"
                  placeholder="ترمینال"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-2"
                label="کد پذیرنده:"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="Gateway.acceptor_code"
                  placeholder="کد پذیرنده"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-2"
                label="نام کاربری:"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="Gateway.username"
                  placeholder="نام کاربری"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-2"
                label="رمز عبور:"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="Gateway.password"
                  placeholder="رمز عبور"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-8"
                label="وضعیت:"
                label-for="input-8"
              >
                <MDDropdown
                  v-bind:group="19"
                  v-model="Gateway.mdid19_status"
                  disabled
                ></MDDropdown>
              </b-form-group>
            </b-col>
            <b-col v-if="Gateway.mdid104_payment_priority != 1658">
              <b-form-group
                id="input-group-8"
                label="زمان تسویه:"
                label-for="input-8"
              >
                <MDDropdown
                  v-bind:group="105"
                  :parent="Gateway.mdid104_payment_priority"
                  v-model="Gateway.mdid105_payment_time"
                  disabled
                ></MDDropdown>
              </b-form-group>
            </b-col>
            <b-col v-else></b-col>
            <b-col></b-col>
            <b-col></b-col>
          </b-row>
        </b-card-body>
      </div>
      <b-card-body title="مشخصات مشتری">
        <hr class="my-4" />
        <br />
        <b-card-text>
          <b-row>
            <b-col cols="4">
              <b-form-group
                id="example-input-group-1"
                label="نوع:"
                label-for="example-input-1"
              >
                <MDDropdown
                  :disabled="false"
                  v-bind:group="17"
                  v-model="user.mdid17_merchant_type"
                ></MDDropdown>
                <b-form-invalid-feedback id="input-1-live-feedback"
                  >وارد کردن نام اجباری است</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
          </b-row>
          <div v-if="user.mdid17_merchant_type == 1550">
            <PersonInfo v-model="user" v-bind:disabled="true"></PersonInfo>
          </div>
          <div v-if="user.mdid17_merchant_type == 1551">
            <CompanyInfo v-model="user" v-bind:disabled="true"></CompanyInfo>
          </div>
          <h4>اطلاعات تماس</h4>
          <UserAddress v-model="user" v-bind:disabled="true"></UserAddress>
        </b-card-text>
      </b-card-body>
      <b-card-body title="وضعیت تاییدیه ها">
        <hr class="my-4" />
        <br />
        <b-card-text>
          <list-table
            :url="userconf.url"
            title="وضعیت تاییدیه ها"
            :detailUrl="userconf.detailUrl"
            :fields="userconf.fields"
            :params="userconf.params"
          ></list-table>
        </b-card-text>
      </b-card-body>
    </b-card>
  </div>
</template>
<style>
.custom-control.custom-checkbox {
  margin-top: 30px;
}
.sc-card-pan {
  direction: ltr;
}
</style>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "../../helpers/httpHelper";
import MDDropdown from "../../components/MDDropdown";
import TableShowData from "../../components/table";
import persianDate from "../../helpers/persianDate";
import PersonInfo from "../Users/PersonInfo";
import CompanyInfo from "../Users/CompanyInfo";
import UserAddress from "../Users/UserAddress";
export default {
  name: "viewGateway",
  data() {
    return {
      trDetail: { location: { countryCode: "IR" } },
      Gateway: {
        id: 0,
        request_status: {},
      },
      message: "",
      errors: [],
      success_errors: [],
      disabled: 0,
      user_info: [],
      fix_price: "accepted",
      percent_price: "accepted",
      user: {},
      userconf: {
        url: "",
        fields: [
          {
            key: "id",
            label: "کد",
          },
          {
            key: "type.title",
            label: "برای",
          },
          {
            key: "status.title",
            label: "وضعیت",
          },
          {
            key: "details",
            label: "جزییات",
          },
        ],
        params: [],
        detailUrl: "editUserConf",
      },

    };
  },
  components: {
    MDDropdown,
    "list-table": TableShowData,
    PersonInfo,
    CompanyInfo,
    UserAddress,
  },
  methods: {
    getUserData() {

      httpHelper.getData("users?id=" + this.user_info.id).then((res) => {
        this.user = res.result;
      });
    },
    getConfData() {
      this.userconf.url = "userconf?user_id=" + this.user_info.id;
    },
   
    LoadData() {
      httpHelper.setAuth();
      httpHelper
        .getData("paymentgateways?id=" + this.$route.params.id)
        .then((res) => {
          if (res.success) {
            var data = res.result;
            this.Gateway = {
              id: data.id,
              pin: data.pin,
              user_card_id: data.user_card_id,
              wallet_id: data.wallet_id,
              mdid9_category: data.mdid9_category,
              mdid12_money_type: data.mdid12_money_type,
              mdid14_direct_gate: data.mdid14_direct_gate,
              mdid20_request_status: data.mdid20_request_status,
              mdid19_status: data.mdid19_status,
              phone_support: data.phone_support,
              website: data.website,
              website_en_name: data.website_en_name,
              website_name: data.website_name,
              description: data.description,
              phone_support: data.phone_support,
              last_trackingNumber: data.last_trackingNumber,
              request_status: data.request_status,
              pre_phone: data.pre_phone,
              pourcents_percent: data.pourcents_percent,
              pourcents_percent_max_value: data.pourcents_percent_max_value,
              pourcents_value: data.pourcents_value,
              terminal: data.terminal,
              acceptor_code: data.acceptor_code,
              username: data.username,
              password: data.password,
              mdid104_payment_priority: data.mdid104_payment_priority,
              mdid105_payment_time: data.mdid105_payment_time,
            };

            if (data.created_at != null) {
              this.Gateway.created_at = persianDate.getDateByFormat(data.created_at);
            } else {
              this.Gateway.created_at = "-";
            }
            this.user_info = data.user;
            this.getUserData();
            this.getConfData();
          }
        });
    },
  },
  created() {
    this.LoadData();
  },
  mounted() {
   this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "لیست درگاه ها",
        route: "merchants",
      },
      {
        title: "جزییات درگاه",
      },
    ]);
  },
};
</script>
